import {
  Eye,
  MousePointerClick,
  ShoppingBag,
  ClipboardCheck,
  CheckCircle2,
} from "lucide-react";

export const STAGES = [
  { key: "visit", title: "Visitas", legend: "visitaram seu cardápio", Icon: Eye },
  { key: "view", title: "Visualizações", legend: "visualizaram algum item", Icon: MousePointerClick },
  { key: "cart", title: "Sacola", legend: "adicionaram itens na sacola", Icon: ShoppingBag },
  { key: "revision", title: "Revisão", legend: "revisaram o pedido", Icon: ClipboardCheck },
  { key: "completed", title: "Concluídos", legend: "concluíram o pedido", Icon: CheckCircle2 },
];

export const PERIOD_OPTIONS = [
  { key: "today", label: "Hoje" },
  { key: "7d", label: "7 dias" },
  { key: "30d", label: "30 dias" },
  { key: "custom", label: "Personalizado" },
];

// Piso progressivo de largura por etapa. Garante que mesmo barras com ratio baixo
// (Concluídos = 25%) sejam visualmente decrescentes e que o texto interno caiba
// centralizado em todas as larguras.
export const FUNNEL_WIDTH_FLOOR = [100, 82, 67, 55, 45];
